'use strict';

var ACC;
ACC.utils = {
    addToLocalStorage: function(storeName, object) {
      localStorage.setItem(storeName, JSON.stringify(object));
    },
    getFromLocalStorage: function(storeName) {
      return JSON.parse(localStorage.getItem(storeName));
    },
    joinUrl: function(base, segment) {
        if (base.endsWith('/')) {
            return base + segment;
        }
        return base + '/' + segment;
    }
};
